import { render, staticRenderFns } from "./storeProductCom.vue?vue&type=template&id=80b42180"
import script from "./storeProductCom.vue?vue&type=script&lang=js"
export * from "./storeProductCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports